import React from "react";
import Directory from "../../components/directory/directory.component";

import "./homepage.styles.scss";

function HomePage(props) {
  return (
    <div className="homepage">
      <Directory />
    </div>
  );
}

export default HomePage;
